<template>
  <!-- 微信二维码回调，现在无法使用 -->
 <div>
 </div>
</template>

<script>
export default {
  data () {
    return {
      openId: '',
      selectVal: '',
      code: '',
      state: '',
      factoryNameList: ['']
    }
  },
  created () {
    console.log('进入回调页面')
    this.selectVal = this.$route.query.selectVal
    console.log(this.selectVal)
    this.code = this.$route.query.code
    console.log(this.code)
    this.state = this.$route.query.state
    console.log(this.state)
    this.postCode()
  },
  methods: {
    postCode () {
      // 平台登陆的二维码回调
      if (this.selectVal === '平台登录') {
        console.log('进入平台登录发送请求')
        this.$request2({
          url: 'wxLogin',
          method: 'POST',
          params: { code: this.code }
        }).then(res => {
          this.$emit('close')
          this.$message.success('登录成功!')
          window.sessionStorage.setItem('token', 'Bearer ' + res.data.token)
          window.sessionStorage.setItem('username', res.data.userInfo.username)
          window.sessionStorage.setItem('id', res.data.userInfo.id)
          window.sessionStorage.setItem('queryFactoryName', '')
          window.sessionStorage.setItem('activePath', 'factories')
          this.$router.push('/platform/home')
        }, rej => {
          this.$emit('close')
        })
        // 工厂登录的二维码回调
      } else if (this.selectVal === '工厂登录') {
        console.log('进入工厂登录发送请求')
        this.$request({
          url: 'wxLogin',
          method: 'POST',
          params: { code: this.code }
        }).then(res => {
          this.$message.success('登录成功')
          window.sessionStorage.setItem('type', this.$params.wx)
          window.sessionStorage.setItem('selectFactoryValue', '')
          window.sessionStorage.setItem('factoryNameList', JSON.stringify(res.data.factoryNameList))
          window.sessionStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
          window.sessionStorage.setItem('id', res.data.userInfo.id)
          window.sessionStorage.setItem('token', 'Bearer ' + res.data.token)
          window.sessionStorage.setItem('factoryId', res.data.userInfo.factoryId)
          this.$router.push('/dashboard')
        }, rej => {
          this.$emit('close')
        })
        // 平台微信绑定的二维码回调
      } else if (this.selectVal === '平台微信绑定') {
        console.log('进入平台微信绑定发送请求')
        this.$request2({
          url: `wxBinding/${window.sessionStorage.getItem('id')}`,
          method: 'POST',
          params: { code: this.code }
        }).then(res => {
          this.$emit('close')
          this.$router.go(-1)
          this.$message.success('微信绑定成功！')
        }, rej => {
          this.$emit('close')
        })
      } else if (this.selectVal === '工厂微信绑定') {
        console.log('进入工厂微信绑定发送请求')
        this.$requestBase({
          url: `factory/wxBinding/${window.sessionStorage.getItem('id')}`,
          method: 'POST',
          params: { code: this.code }
        }).then(res => {
          this.$emit('close')
          this.$router.go(-1)
          this.$message.success('微信绑定成功！')
        }, rej => {
          this.$emit('close')
        })
      } else if (this.selectVal === '解除工厂微信绑定') {
        console.log('进入解除工厂微信绑定发送请求')
        this.$requestBase({
          url: `factory/wxUnbinding/${window.sessionStorage.getItem('id')}`,
          method: 'POST',
          params: { code: this.code }
        }).then(res => {
          this.$emit('close')
          this.$router.go(-1)
          this.$message.success('微信解除绑定成功！')
        }, rej => {
          this.$emit('close')
        })
      } else if (this.selectVal === '解除平台微信绑定') {
        console.log('进入解除平台微信绑定发送请求')
        this.$request2({
          url: `wxUnbinding/${window.sessionStorage.getItem('id')}`,
          method: 'POST',
          params: { code: this.code }
        }).then(res => {
          this.$emit('close')
          this.$router.go(-1)
          this.$message.success('微信解除绑定成功！')
        }, rej => {
          this.$emit('close')
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
